export function nearestSettledStory(
  distances: readonly number[],
  tolerance = 3,
): number | null {
  if (!Number.isFinite(tolerance) || tolerance < 0) return null;

  let closest = -1;
  let gap = Number.POSITIVE_INFINITY;

  distances.forEach((distance, index) => {
    const candidate = Math.abs(distance);
    if (Number.isFinite(candidate) && candidate < gap) {
      closest = index;
      gap = candidate;
    }
  });

  return closest >= 0 && gap <= tolerance ? closest : null;
}

export function nextStillFrame(
  previous: number,
  current: number,
  stillFrames: number,
): number {
  if (![previous, current, stillFrames].every(Number.isFinite)) return 0;
  return Math.abs(current - previous) < 0.5
    ? Math.min(stillFrames + 1, 10)
    : 0;
}
